export const treatmentTypeOptions: {
    value: string;
    label: string;
    disabled: boolean
}[] = [
        { value: "Reauthorization", label: "Reauthorization", disabled: false },
        { value: "InitialTreatment", label: "Initial treatment", disabled: false },
        { value: "Dispute", label: "Dispute of previous denial (within 180 days of denial date)", disabled: false },
    ];

export const typeOptions = treatmentTypeOptions.map(o => o.value);